import { defineStore } from 'pinia';
import _ from 'lodash';
import type { FlowStep } from '@Shared';
import type { FlowTask } from '@Types/FlowTask.interface';
import { getClientFlowApi } from '@Api/clientFlow.api';
import { FLOW_DEFINITIONS, isFeatureFlowType } from '@Constants/esignatureFlow.constant';

// TODO: Create your own flow type for your MFE
import { EsignatureFlowType } from '@Enums/esignatureFlowType.enum';

export const useEsignatureFlowStore = defineStore('esignatureFlow', {
    state: () => ({
        currentRoute: null as string | null,
        flowSteps: [] as FlowTask[]
    }),
    actions: {
        // TODO: Load Esignature flow steps from your API
        async loadEsignatureFlow() {
            const requiredFlows = await getClientFlowApi();
            const mappedFlows = this._getRequiredStepsFromFlow(requiredFlows);
            
            this._buildFlowSequence(mappedFlows); 
            console.log('Computed Flow Map:', this.flowSteps);

        },
        // TODO: Validate flow steps against internal definitions
        _getRequiredStepsFromFlow(rawFlows: FlowStep[]): EsignatureFlowType[] {
            const steps = _.map(rawFlows, 'stepName');
            const validFlows = _.filter(steps, isFeatureFlowType);
            const invalidFlows = _.reject(steps, isFeatureFlowType);
        
            if (!_.isEmpty(invalidFlows)) {
                console.warn("Received unknown payment flows from API:", invalidFlows);
            }
        
            return validFlows
        },
        // TODO: Implement flow sequence building for your client flow type
        _buildFlowSequence(requiredFlows: EsignatureFlowType[]) {
            this.flowSteps = [];
        
            for (const flow of requiredFlows) {
                const tasks = FLOW_DEFINITIONS[flow];
                this.flowSteps.push(...tasks);
            }

        },
        getCurrentFlowTask():FlowTask | null {
            const currentFlowTask = _.find(this.flowSteps, { routeName: this.currentRoute }) as FlowTask | undefined;
            return _.isNil(currentFlowTask) ?
                _.head(this.flowSteps) ?? null : 
                currentFlowTask;
        },
        getNextFlowTask():FlowTask | null {
            const currentIndex = _.findIndex(this.flowSteps, { routeName: this.currentRoute ?? undefined });
            const nextFlowTask = _.get(this.flowSteps, currentIndex + 1, null);
            this.currentRoute = nextFlowTask?.routeName ?? null;

            return nextFlowTask;
        },
        getPreviousFlowTask():FlowTask | null {
            const currentIndex = _.findIndex(this.flowSteps, { routeName: this.currentRoute ?? undefined });
            const prevFlowTask = _.get(this.flowSteps, currentIndex - 1, null);
            this.currentRoute = prevFlowTask?.routeName ?? null;

            return prevFlowTask;
        },
        setCurrentRoute(routeName: string) {
            // ensure routeName is a valid route in the flow
            const route = _.find(this.flowSteps, { 'routeName': routeName });
            if (!route) {
                throw new Error(`Route ${routeName} is not part of the current flow`);
            }
            this.currentRoute = routeName;
        },

    }
});